import React, {useState, useEffect,useRef, memo} from 'react';
import styled from 'styled-components';
import {Col, Container, Form, Row} from "react-bootstrap";
import Button from "../Button";
import {toast} from "react-toastify";
import {Img} from "../Img";
import {useForm} from "react-hook-form";
import {postForm} from "../../api/redux/home";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {black, darkBlue, hover, text} from "../../styles/globalStyleVars";

const ListWithForm = ({data}) => {


    const dispatch = useDispatch();
    const responseData = useSelector(state => state.contact);

    const {register, handleSubmit ,formState,reset} = useForm({mode: 'all'});

    //--- form submit
    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });
    const onSubmit = (e) => {

        let api_services = apiEndPoints.CONTACT_FORM;

        var formData = new FormData();
        formData.append('your-name', e?.name);
        formData.append('your-email', e?.email);
        formData.append('your-phone', e?.phone);
        formData.append('your-message', e?.message);

        if (e.email !== '' && e.name !== '' && e.phone !== '' && e?.message!=='') {
            dispatch(postForm([api_services, formData]));
            success('Successfully Submitted')
            reset();
        }
    };
    let count=0;
    const onError = (errors) => {
        Object.values(errors).forEach((error) => {
            count++;
        });
        if(count>0){
            toast.error('please fill out the correct inputs');
        }
        count=0;
    };
    useEffect(() => {
        if (responseData && responseData?.error !== '') {
            error(responseData?.error)
        }
        if (responseData && responseData?.success !== '') {
            // success(responseData?.success)
        }

    }, [responseData])

    return (
        <StyledListWithForm >
            <div className="form_wrapper">
                {data?.title && <h5 >{data?.title}</h5>}

                <Form className={'form'}  onSubmit={handleSubmit(onSubmit,onError)}>
                    <input name={'spam_protector'} type='hidden'/>
                    {/*<input name={'form_id'}  value={'contact-form'} type='hidden'/>*/}
                    <div className="form-group">
                        <Form.Group controlId="formBasicEmail">

                            <Form.Control  className={formState?.errors?.name?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                           {...register("name",{
                                               required: 'Username is required',
                                           })}
                                           type="text"
                                           placeholder="Full name"
                            />
                        </Form.Group>
                    </div>
                    <div className="form-group">
                        <Form.Group controlId="formBasicPhone">

                            <Form.Control className={formState?.errors?.phone?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                          {...register("phone",{
                                              required:{
                                                  value:true,
                                                  message:'please enter your phone first'
                                              },
                                              pattern:{
                                                  value:/^01[0-9]{9}$/,
                                                  message:'please enter a valid 11 digit phone number'
                                              }
                                          })}
                                          type="number"
                                          placeholder="Number*"/>
                        </Form.Group>
                    </div>
                    <div className="form-group">
                        <Form.Group controlId="formBasicEmail">

                            <Form.Control  className={formState?.errors?.email?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                           {...register("email",{
                                               required:{
                                                   value:true,
                                                   message:'please enter your email'
                                               },
                                               pattern:{
                                                   value:/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                   message:'please enter a valid email address'
                                               }
                                           })}
                                           type="email"
                                           placeholder="Email*"/>
                        </Form.Group>
                    </div>

                    <div className="form-group">
                        <Form.Group controlId="formBasicPhone">

                            <Form.Control className={formState?.errors?.message?.message ? 'has-error form-control-lg' : 'form-control-lg'}
                                          {...register("message",{
                                              required:{
                                                  // value:true,
                                                  message:'please enter your email'
                                              },

                                          })}
                                          type="textarea"
                                          placeholder="Message"/>
                        </Form.Group>
                    </div>

                    <div className={`'form-group width-fit'}`} >
                        <div onClick={handleSubmit(onSubmit,onError)}>
                            <Button width={'fit-content'} text={'Submit Message'} color={`${black}`} hoverBackground={`${hover}`} border={`1px solid ${text}`} margin={'60px 0 0 0'}/>
                        </div>
                    </div>
                </Form>
            </div>
        </StyledListWithForm>
    )
};

const StyledListWithForm = styled.div`
  .form_wrapper {
    height: 100%;
    h5{
      color: ${darkBlue};
      margin-bottom: 60px;
    }
    form {
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: space-between;
    }

    .title {
      font-size: 24px;
      font-weight: 4000;
      line-height: 28px;
      color: #F9F9F9;
      margin: 0 0 40px;
    }

    .form-group {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .form-control {
        box-shadow: none;
        outline: 0;
        border-radius: 0;
        background: transparent;
        height: auto;
        border-left: none;
        border-right: none;
        border-top: none;
        border-color: rgba(198, 198, 198, 0.5);
        padding: 0 0 8px;
        color: #3C3C3B;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;

        &:focus{
          border-color: #3C3C3B;
        }
        &::placeholder {
          color: #C6C6C6;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
        input[type="textarea"]{
          padding-bottom: 80px !important;
        }
      }
      
      textarea{
        min-height: 80px;
      }
    }


    .filter__placeholder {
      color: #C4C4C4;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }

    .filter__control {
      height: 30px !important;
      padding: 0 !important;
      background: transparent !important;
      border-left: none !important;
      border-right: none !important;
      border-top: none !important;
      border-color: rgba(246, 246, 247, 0.2) !important;

      .filter__single-value {
        color: #C4C4C4 !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
      }

      .filter__indicator-separator {
        display: none;
      }

      .filter__value-container {
        padding: 0;
      }

      .filter__dropdown-indicator, .filter__input-container, .filter__placeholder {
        margin: 0;
      }
    }
  }
  input[type="textarea"]{
    padding-bottom: 80px !important;
  }
  @media (max-width: 767px) {
    padding-top: 0;
    padding-bottom: 0;
    .form_wrapper {
      padding: 60px 0px;
      margin-top: 0px;
    }
  }
`;

export default React.memo(ListWithForm);
